import Vue from 'vue'
import Vuex from 'vuex'
import AuthModule from './modules/Auth/AuthModule'
import CartModule from './modules/Cart/CartModule'
import TransactionModule from './modules/Transaction/TransactionModule'
import CustomerModule from './modules/Customer/CustomerModule'
import PromoModule from './modules/Promo/PromoModule'
import EmployeeModule from './modules/Employee/EmployeeModule'
import SessionModule from './modules/Session/SessionModule'
import SnackbarModal from './modules/SnackbarModal/SnackbarModalModule'
import SpinnerModule from './modules/Spinner/SpinnerModule'
import MobileSnackbarModule from './modules/MobileSnackbar/MobileSnackbarModule'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        AuthModule,
        CartModule,
        TransactionModule,
        CustomerModule,
        PromoModule,
        EmployeeModule,
        SessionModule,
        SnackbarModal,
        SpinnerModule,
        MobileSnackbarModule,
    },
    state: {},
    actions: {},
    getters: {},
})
